export enum PropertyType {
  AMOUNT = 'am',
  ANCHOR = 'a',
  ANGLE = 'an',
  OPACITY = 'o',
  POSITION = 'p',
  POINTS = 'pt',
  ROTATION = 'r',
  ROTATION_X = 'rx',
  ROTATION_Y = 'ry',
  ROTATION_Z = 'rz',
  SCALE = 's',
  SKEW_AXIS = 'sa',
  SKEW = 'sk',
  SHAPE = 'sh',
  EXPANSION = 'x',
  FEATHER = 'f',
  SIZE = 'sz',
  ROUNDNESS = 'rd',
  MITER_LIMIT = 'ml',
  STROKE_WIDTH = 'sw',
  NUMBER = 'nu',
  COLOR = 'cl',
  ORIENTATION = 'or',
  GRADIENT = 'gr',
  EFFECT_VALUE = 'v',
  TEXT_DATA = 'd',
  TEXT_ALIGNMENT = 'ta',
  MAX_EASE = 'xe',
  MIN_EASE = 'ne',
  MAX_AMOUNT = 'ma',
  RANGE_UNITS = 'rn',
  OFFSET = 'of',
  EXPRESSION_SELECTOR = 'sm',
  START = 'st',
  END = 'e',
  SATURATION = 'fs',
  HUE = 'fh',
  BRIGHTNESS = 'fb',
  TEXT_TRACKING = 't',
  CENTER = 'cn',
  RADIUS = 'ra',
  DISTANCE = 'ds',
}
